import kformUtils from "../../utils/kform-utils";

export default /* @ngInject */ (/** @type {any} */ $scope) => {
	$scope.maskOptions = {
		inputMask: String,
	};

	if ($scope.options?.building) {
		return;
	}

	$scope.changeValue = () => {
		if (typeof $scope.component.event.onChange === 'string') {
			const custom = ''.concat($scope.component.event.onChange, '; ');
			kformUtils.evaluate(custom, {
				data: $scope.data,
				form: $scope.form,
			});
		}
	};
};
